// @flow
import React from 'react'
import ReactDOM from 'react-dom'
import CanvasDraw from '../../packages/er2-react-canvas-draw/src'
import stylesFicus from '../styles'

type Props = {
    color: string,
    hasAnalysisPanel: boolean,
    hasHeader: boolean,
    height: number,
    inactive: boolean,
    onSaveLine: Function,
    theme: stylesFicus,
    tocVisible: boolean,
    width: number,
}

class Mapbrusher extends React.PureComponent<Props> {
    state = {
        color: '#ffc600',
        brushRadius: 10,
        lazyRadius: 12,
    }

    canvas: CanvasDraw = null
    render() {
        // Overlay over map
        const classNames = [this.props.theme.mapCtr, this.props.theme.mapToolbarPanelClosed]
        if (document.documentMode || /Edge/.test(navigator.userAgent)) {
            if (!this.props.hasAnalysisPanel) classNames.push(this.props.theme.moveDown)
        } else {
            classNames.push(this.props.hasAnalysisPanel ? this.props.theme.analysisPanelOpen : this.props.theme.analysisPanelClosed)
        }
        classNames.push(this.props.tocVisible ? this.props.theme.contextBarOpen : this.props.theme.contextBarClosed)
        classNames.push(this.props.hasHeader ? this.props.theme.headerPanelOpen : this.props.theme.headerPanelClosed)

        const root = document.getElementById('app_root')

        return ReactDOM.createPortal(
            <div
                className={classNames.join(' ')}
                style={{
                    opacity: 0.5,
                    height: '100%',
                    width: '100%',
                    zIndex: 10,
                    pointerEvents: this.props.inactive ? 'none' : undefined,
                }}
            >
                <CanvasDraw
                    ref={canvasDraw => (this.canvas = canvasDraw)}
                    brushColor={this.props.color}
                    brushRadius={this.state.brushRadius}
                    hideGrid
                    lazyRadius={this.state.lazyRadius}
                    canvasWidth={this.props.width}
                    canvasHeight={this.props.height}
                    onSaveLine={this.props.onSaveLine}
                    style={{
                        backgroundColor: 'transparent',
                    }}
                />
            </div>,
            root,
        )
    }
}

export default Mapbrusher
